import { render, staticRenderFns } from "./rijbewijs-ce.vue?vue&type=template&id=ca0676bc"
import script from "./rijbewijs-ce.vue?vue&type=script&lang=js"
export * from "./rijbewijs-ce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports